import { Theme } from '@mui/material/styles';

export default function IconButton(theme: Theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32,
          borderRadius: 4,
        },
      },
    },
  };
}
